module.exports = __webpack_public_path__ + "img/img7.e3d7df3d.png";